import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 0,
  class: "a-pop-title"
};
const _hoisted_3 = {
  class: "a-pop-btn-box"
};
const _hoisted_4 = {
  key: 1,
  class: "a-pop-notes"
};
import { computed } from 'vue';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
export default {
  __name: 'PopUp',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    btnConfirmText: {
      type: String,
      default: ''
    },
    btnConfirmShow: {
      type: Boolean,
      default: true
    },
    btnCancelText: {
      type: String,
      default: ''
    },
    btnCancelShow: {
      type: Boolean,
      default: false
    },
    content: {
      type: String
    },
    privateStyle: {
      type: Boolean
    },
    isOverCartMaxLimit: {
      require: false,
      type: Boolean,
      default: false
    },
    isManualClose: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:show', 'close', 'confirm', 'closed'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('components/PopUp.less');
    const {
      t
    } = useI18n();
    const showVal = computed({
      get: () => props.show,
      set: val => {
        emit('update:show', val);
      }
    });
    const textConfimBtn = computed(() => {
      return props.btnConfirmText ? props.btnConfirmText : t('button.CONFIRM');
    });
    const textCancelBtn = computed(() => {
      return props.btnCancelText ? props.btnCancelText : t('button.CANCEL');
    });
    const handleClose = isOverCartMaxLimit => {
      if (!isOverCartMaxLimit) {
        emit('close');
      }
      showVal.value = false;
    };
    const handelConfirm = () => {
      emit('confirm');
      if (!props.isManualClose) showVal.value = false;
    };
    const handleClosed = () => {
      emit('closed');
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        class: "a-pop",
        show: showVal.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showVal.value = $event),
        "overlay-class": "a-overlay-white",
        onClickOverlay: _cache[3] || (_cache[3] = $event => handleClose(__props.isOverCartMaxLimit)),
        onClosed: handleClosed
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "a-pop-close-icon",
          onClick: _cache[0] || (_cache[0] = $event => handleClose(__props.isOverCartMaxLimit))
        }, [_createElementVNode("img", {
          src: `${_unref(constants).IMAGE_URL}assets/svg/close.svg`,
          alt: ""
        }, null, 8, _hoisted_1)]), __props.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(['a-pop-content', __props.privateStyle ? 'lh' : ''])
        }, [_ctx.$slots.content ? _renderSlot(_ctx.$slots, "content", {
          key: 0
        }) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(__props.content), 1)], 64))], 2), _createElementVNode("div", _hoisted_3, [__props.btnCancelShow ? (_openBlock(), _createBlock(_component_van_button, {
          key: 0,
          color: "#FAFAFA",
          class: "cancel-btn",
          onClick: _cache[1] || (_cache[1] = $event => handleClose())
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(textCancelBtn.value), 1)]),
          _: 1
        })) : _createCommentVNode("", true), __props.btnConfirmShow ? (_openBlock(), _createBlock(_component_van_button, {
          key: 1,
          color: "#EB1745",
          class: "confirm-btn",
          block: !__props.btnCancelShow,
          onClick: handelConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(textConfimBtn.value), 1)]),
          _: 1
        }, 8, ["block"])) : _createCommentVNode("", true)]), _ctx.$slots.notes ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_renderSlot(_ctx.$slots, "notes")])) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["show"]);
    };
  }
};